module.exports = __webpack_public_path__ + "fonts/dystopian-black.0d1a4593.woff2";